// Utility functions for input masks

export function phoneMask(value: string): string {
  if (!value) return '';
  const cleaned = value.replace(/\D/g, '');

  if (cleaned.length <= 10) {
    // Formato: (XX) XXXX-XXXX
    return cleaned
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .substring(0, 14);
  } else {
    // Formato: (XX) XXXXX-XXXX
    return cleaned
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .substring(0, 15);
  }
}

export function cpfMask(value: string): string {
  if (!value) return '';
  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
    .substring(0, 14);
}

// Remove all non-numeric characters
export function unmask(value: string): string {
  return value.replace(/\D/g, '');
}
